import { ToastManagerProps } from './types';
import styled from 'styled-components';
import { s16, s32, zIndex } from '@ardoq/design-tokens';
import { Toast } from './Toast';
import { connect, spreadMap } from '@ardoq/rxbeach';
import { toastTop$, toastBottom$ } from './toast$AndRoutine';
import { combineLatest } from 'rxjs';

// This + padding top makes sure toast appear in exactly 128px from the top, padding makes the animation smoother
const DEFAULT_OFFSET_TOP = 112;
const DEFAULT_OFFSET_BOTTOM = 32;

const ToastsContainer = styled.div<{ $isBottom: boolean }>`
  position: fixed;
  display: flex;
  flex-direction: ${props => (props.$isBottom ? 'column-reverse' : 'column')};
  ${props => (props.$isBottom ? 'bottom: 0;' : 'top: 0;')}
  right: ${s32};
  ${props =>
    props.$isBottom ? `padding-bottom: ${s16};` : `padding-top: ${s16};`}
  padding-left: ${s16}; /* needs some padding here so that the box shadow of the toast is not clipped */
  gap: ${s16};
  z-index: ${zIndex.TOAST};
  align-items: flex-end;
  height: 400px; /* needs some height so that the toast that are pushed have some space to disappear into */
  overflow: hidden;
  pointer-events: none; /* to avoid blocking user interaction */
`;

type ToastManagerCombinedProps = {
  offsetTop?: number;
  topToasts: ToastManagerProps['toasts'];
  bottomToasts: ToastManagerProps['toasts'];
};

const ToastManagerContent = ({
  offsetTop = DEFAULT_OFFSET_TOP,
  topToasts,
  bottomToasts,
}: ToastManagerCombinedProps) => (
  <>
    {topToasts.length > 0 && (
      <ToastsContainer $isBottom={false} style={{ top: offsetTop }}>
        {topToasts.map(props => (
          <Toast {...props} key={props.id} />
        ))}
      </ToastsContainer>
    )}
    {bottomToasts.length > 0 && (
      <ToastsContainer
        $isBottom={true}
        style={{ bottom: DEFAULT_OFFSET_BOTTOM }}
      >
        {bottomToasts.map(props => (
          <Toast {...props} key={props.id} />
        ))}
      </ToastsContainer>
    )}
  </>
);

export const ToastManager = connect(
  ToastManagerContent,
  combineLatest([toastTop$, toastBottom$]).pipe(
    spreadMap((topState, bottomState) => ({
      topToasts: topState.toasts,
      bottomToasts: bottomState.toasts,
    }))
  )
);
